import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { SidebarMenuItems } from './menu-items';
import { Router, ActivatedRoute } from '@angular/router';
import { User } from '../../../models/user';
import { RolesResourceEnum } from '../../../models/roles.resource';
import { AuthenticationService } from '../../../services/authentication/authentication.service';
import { SpinnerService } from '../../../services/spinner/spinner.service';
import { SidebarService } from '../../../services/sidebar/sidebar.service';

declare let $: any;
@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html'
})
export class SidebarComponent implements OnInit {
  @Output() toggleSidebar = new EventEmitter<void>();

  private rolesResource = RolesResourceEnum;
  showMenu = '';
  ruoloUser: string;
  roleSuperAdmin: boolean = false;
  ruoloAdmin: boolean = false;
  currentUser: User;
  isSidebarOpen: boolean = true;
  public sidebarnavItems: any[] = [];
  role: any;


  constructor(
    private authenticationService: AuthenticationService,
    public spinnerService: SpinnerService,
    private sidebarService: SidebarService,
    private router: Router,
    private route: ActivatedRoute,
  ) {
    this.sidebarService.openSidebar.subscribe(open => this.isSidebarOpen = open);
    this.authenticationService.currentUser.subscribe(x => this.currentUser = x);
  }

  ngOnInit() {
    if (this.router.url !== '/') {
      this.role = this.getRole();
      this.sidebarnavItems = this.getSidebarnavItems(this.role);
    }


    //Gestione ruolo utente
    this.roleSuperAdmin = true;
    this.ruoloAdmin = true;
  }


  getSidebarnavItems(role: string): any[] {
    let sidebar = [];
    let sidebarConfig = SidebarMenuItems.filter(sidebarnavItem => sidebarnavItem);
    switch (role) {
      case this.rolesResource.ROLE_ADMIN: sidebar = sidebarConfig; break;
      case this.rolesResource.ROLE_NOOVLE: sidebar = sidebarConfig; break;
      case this.rolesResource.ROLE_STOREMANAGER_FRANCHISING: sidebar = this.getSidebarnavItemsFranchising(sidebarConfig); break;
      case this.rolesResource.ROLE_STOREMANAGER_GDS: sidebar = this.getSidebarnavItemsMultibrandEGDS(sidebarConfig); break;
      case this.rolesResource.ROLE_STOREMANAGER_MULTIBRAND: sidebar = this.getSidebarnavItemsMultibrandEGDS(sidebarConfig); break;
      case this.rolesResource.ROLE_STOREMANAGER_FLAGSHIP_MONOBRAND: sidebar = this.getSidebarnavItemsMonobrand(sidebarConfig); break;
      case this.rolesResource.ROLE_STOREMANAGER_SUPERVISOR: sidebar = this.getSidebarnavItemsSupervisor(sidebarConfig); break;
      case this.rolesResource.ROLE_STORES_UPLOAD_MANAGER: sidebar = this.getSidebarnavItemsUploadManager(sidebarConfig); break;
    }
    return sidebar;
  }

  getSidebarnavItemsMonobrand(sidebarConfig) {
    let newMenu = [];
    let menuIndex: number;
    let subMenuArray = [];
    let subMenu = [];

    //Appuntamenti
    subMenu = [];
    menuIndex = sidebarConfig.findIndex(menu => menu.title === 'Appuntamenti');
    newMenu.push(sidebarConfig[menuIndex]);
    subMenuArray = newMenu[newMenu.length - 1];
    subMenuArray = subMenuArray['submenu'];
    for (let obj of subMenuArray) {
      if (
        obj.path == 'appointment/appointment-times' ||
        obj.path == 'appointment/calendar') {
        subMenu.push(obj);
      }
    }
    newMenu[newMenu.length - 1]['submenu'] = subMenu;

    //Prenota e ritira
    subMenu = [];
    menuIndex = sidebarConfig.findIndex(menu => menu.title === 'Prenota e ritira');
    newMenu.push(sidebarConfig[menuIndex]);
    subMenuArray = newMenu[newMenu.length - 1];
    subMenuArray = subMenuArray['submenu'];
    for (let obj of subMenuArray) {
      if (obj.path == 'clickandcollect/sim') {
        subMenu.push(obj);
      }
    }
    newMenu[newMenu.length - 1]['submenu'] = subMenu;

    //Digital coupon
    subMenu = [];
    menuIndex = sidebarConfig.findIndex(menu => menu.title === 'Digital coupon');
    newMenu.push(sidebarConfig[menuIndex]);
    newMenu[newMenu.length - 1]['submenu'] = subMenu;

    //store
    subMenu = [];
    menuIndex = sidebarConfig.findIndex(menu => menu.title === 'Store');
    newMenu.push(sidebarConfig[menuIndex]);
    subMenuArray = newMenu[newMenu.length - 1];
    subMenuArray = subMenuArray['submenu'];
    for (let obj of subMenuArray) {
      if (obj.path == 'store/gestioneorari') {
        subMenu.push(obj);
      }
    }
    newMenu[newMenu.length - 1]['submenu'] = subMenu;
    return newMenu;
  }

  getSidebarnavItemsFranchising(sidebarConfig) {
    let newMenu = [];
    let menuIndex: number;
    let subMenuArray = [];
    let subMenu = [];

    //Appuntamenti
    subMenu = [];
    menuIndex = sidebarConfig.findIndex(menu => menu.title === 'Appuntamenti');
    newMenu.push(sidebarConfig[menuIndex]);
    subMenuArray = newMenu[newMenu.length - 1];
    subMenuArray = subMenuArray['submenu'];
    for (let obj of subMenuArray) {
      if (
        obj.path == 'appointment/appointment-times' ||
        obj.path == 'appointment/calendar') {
        subMenu.push(obj);
      }
    }
    newMenu[newMenu.length - 1]['submenu'] = subMenu;

    //Prenota e ritira
    subMenu = [];
    menuIndex = sidebarConfig.findIndex(menu => menu.title === 'Prenota e ritira');
    newMenu.push(sidebarConfig[menuIndex]);
    subMenuArray = newMenu[newMenu.length - 1];
    subMenuArray = subMenuArray['submenu'];
    for (let obj of subMenuArray) {
      if (obj.path == 'clickandcollect/sim') {
        subMenu.push(obj);
      }
    }
    newMenu[newMenu.length - 1]['submenu'] = subMenu;

    //Digital coupon
    subMenu = [];
    menuIndex = sidebarConfig.findIndex(menu => menu.title === 'Digital coupon');
    newMenu.push(sidebarConfig[menuIndex]);
    newMenu[newMenu.length - 1]['submenu'] = subMenu;

    //store
    subMenu = [];
    menuIndex = sidebarConfig.findIndex(menu => menu.title === 'Store');
    newMenu.push(sidebarConfig[menuIndex]);
    subMenuArray = newMenu[newMenu.length - 1];
    subMenuArray = subMenuArray['submenu'];
    for (let obj of subMenuArray) {
      if (obj.path == 'store/gestioneorari') {
        subMenu.push(obj);
      }
    }
    newMenu[newMenu.length - 1]['submenu'] = subMenu;
    return newMenu;
  }

  getSidebarnavItemsMultibrandEGDS(sidebarConfig) {
    let newMenu = [];
    let subMenu = [];
    let subMenuArray = [];
    let menuIndex: number;

    //Prenota e ritira
    menuIndex = sidebarConfig.findIndex(menu => menu.title === 'Prenota e ritira');
    newMenu.push(sidebarConfig[menuIndex]);
    subMenuArray = newMenu[newMenu.length - 1];
    subMenuArray = subMenuArray['submenu'];
    for (let obj of subMenuArray) {
      if (obj.path == 'clickandcollect/sim') {
        subMenu.push(obj);
      }
    }
    newMenu[newMenu.length - 1]['submenu'] = subMenu;

    //Digital coupon
    subMenu = [];
    menuIndex = sidebarConfig.findIndex(menu => menu.title === 'Digital coupon');
    newMenu.push(sidebarConfig[menuIndex]);
    newMenu[newMenu.length - 1]['submenu'] = subMenu;

    return newMenu;
  }


  getSidebarnavItemsSupervisor(sidebarConfig) {
    let newMenu = [];
    let menuIndex: number;
    let subMenuArray = [];
    let subMenu = [];

    //Appuntamenti
    subMenu = [];
    menuIndex = sidebarConfig.findIndex(menu => menu.title === 'Appuntamenti');
    newMenu.push(sidebarConfig[menuIndex]);
    subMenuArray = newMenu[newMenu.length - 1];
    subMenuArray = subMenuArray['submenu'];
    for (let obj of subMenuArray) {
      if (
        obj.path == 'appointment/appointment-times' ||
        obj.path == 'appointment/calendar') {
        subMenu.push(obj);
      }
    }
    newMenu[newMenu.length - 1]['submenu'] = subMenu;

    //Digital coupon
    subMenu = [];
    menuIndex = sidebarConfig.findIndex(menu => menu.title === 'Digital coupon');
    newMenu.push(sidebarConfig[menuIndex]);
    newMenu[newMenu.length - 1]['submenu'] = subMenu;

    //store
    subMenu = [];
    menuIndex = sidebarConfig.findIndex(menu => menu.title === 'Store');
    newMenu.push(sidebarConfig[menuIndex]);
    subMenuArray = newMenu[newMenu.length - 1];
    subMenuArray = subMenuArray['submenu'];
    for (let obj of subMenuArray) {
      if (obj.path == 'store/gestioneorari') {
        subMenu.push(obj);
      }
    }
    newMenu[newMenu.length - 1]['submenu'] = subMenu;
    return newMenu;
  }

  getSidebarnavItemsUploadManager(sidebarConfig) {
    let newMenu = [];
    let menuIndex: number;
    menuIndex = sidebarConfig.findIndex(menu => menu.title === 'XML - 2');
    newMenu.push(sidebarConfig[menuIndex]);
    return newMenu;
  }


  // this is for the open close
  addExpandClass(element: any) {
    if (element === this.showMenu) {
      this.showMenu = '0';
    } else {
      this.showMenu = element;
    }
  }

  toggleSide(liName) {
    if (!liName.currentTarget.classList.contains('has-arrow')) {
      this.toggleSidebar.emit();
    }
    if (liName.currentTarget.classList.contains('sidebar-link')) {
      this.isSidebarOpen = !this.isSidebarOpen;
      this.sidebarService.toggleSidebar(this.isSidebarOpen);
    }


  }

  toggleLabels() {
    this.sidebarService.toggleSidebar(!this.isSidebarOpen);
  }


  isSameLabel(label) {
    return this.showMenu === label;
  }

  getRole() {
    let res = "";
    for (let i = 0; i < this.currentUser.userBackend.authorities.length && res == ""; i++) {
      if (this.currentUser.userBackend.authorities[i].authority.startsWith("ROLE_")) {
        res = this.currentUser.userBackend.authorities[i].authority;
      }
    }
    return res;
  }

}
